module.exports = __webpack_public_path__ + "img/f-2-2.97ab199.png";